import { Ship } from 'lucide-react';
import { FOCUS_RING } from '../../vessel-changes';
import type { EmployeeNotification } from '../api/employeeNotificationsApi';
import { isSystemNotice } from '../model/vesselNotices';
import { showWhen } from './noticeTime';

/** One vessel notice: a blue dot while unread, a grey ship (red only for system problems), one line of body. */
export const VesselNoticeRow = ({ notice, onOpen }: { notice: EmployeeNotification; onOpen: (notice: EmployeeNotification) => void }) => (
  <li>
    <button
      type="button"
      onClick={() => onOpen(notice)}
      className={`flex w-full items-start gap-2 px-3 py-2 text-left transition-colors hover:bg-slate-50 ${FOCUS_RING}`}
    >
      <span aria-hidden data-unread={!notice.read}
        className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${notice.read ? 'bg-transparent' : 'bg-blue-500'}`} />
      <Ship aria-hidden className={`mt-0.5 h-3.5 w-3.5 shrink-0 ${isSystemNotice(notice) ? 'text-red-500' : 'text-slate-400'}`} />
      <span className="min-w-0 flex-1">
        <span className="flex items-baseline justify-between gap-2">
          <span className={`truncate text-xs ${notice.read ? 'font-normal text-slate-600' : 'font-medium text-slate-900'}`}>
            {!notice.read && <span className="sr-only">Unread: </span>}
            {notice.title}
          </span>
          <span className="shrink-0 text-[10px] tabular-nums text-slate-400">{showWhen(notice.createdDate)}</span>
        </span>
        {notice.body && <span className="line-clamp-1 text-[11px] text-slate-500">{notice.body}</span>}
      </span>
    </button>
  </li>
);
